import React, { useEffect, useState } from 'react';
import { 
  Avatar, Button, Col, 
  Dropdown, MenuProps, Row, Space, 
} from 'antd';
import useAuth from '@/hooks/useAuth';
import { 
  DownOutlined, 
  FireOutlined, 
  LogoutOutlined, 
  NotificationOutlined,
} from '@ant-design/icons';
import useCustomTranslation from '@/hooks/useCustomTranslation';
import { getMasterFranchiseConfigurations } from '@/services/MasterFranchiseConfigurationService';

const TopbarProfile = () => {
  const auth = useAuth();
  const [feedbackUrl, setFeedbackUrl] = useState<string>();
  const { t } = useCustomTranslation();
  
  const items: MenuProps['items'] = [
    {
      label: t('g.request_help'),
      key: 'request_help',
      icon: <NotificationOutlined />,
      disabled: !feedbackUrl,
      onClick: () => window.open(feedbackUrl, '_blank', 'noopener,noreferrer'),
    },
    {
      label: t('g.to_reset'),
      key: 'reset',
      danger: true,
      icon: <FireOutlined />,
      onClick: () => auth?.reset(),
    },
    {
      label: 'Cerrar sesión',
      key: 'logout',
      danger: true,
      icon: <LogoutOutlined />,
      onClick: () => auth?.logout(),
    },
  ];
  useEffect(() => {
    getMasterFranchiseConfigurations({ masterFranchiseId: 1 })
      .then((configs) => {
        setFeedbackUrl(configs.find(c => c.key === 'feedback_url')?.value);
      })
      .catch(() => {
      });
  }, []);

  return (
    <Row>
      <Col span={24}>
        <Dropdown 
          menu={{ items }} 
          placement="bottomRight"
          arrow
          trigger={['click']}
        >
          <Button 
            type="link"
            icon={(
              <Avatar 
                alt="user avatar"
                src={auth?.staff?.photoUrl} 
              />
            )}
            style={{ 
              color: '#212529', 
              padding: 0,
            }}
          >
            <Space align="center">
              {auth?.staff?.name}
              <DownOutlined style={{ marginBottom: '6px' }} />
            </Space>
          </Button>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default TopbarProfile;
